<template>
  <div class="w-100 mt-5">
    <h2 class="title font-weight-bold">{{ $t('main.purchasePlan.iconsBlock.title') }}</h2>
    <div class="d-flex justify-content-center flex-wrap">
      <div v-for="(item, index) in items" :key="index" class="svg-box m-5 text-center">
        <Icon
          :exp-active="true"
          :icon="item.icon"
          :stroke="false"
          :width="50"
          :height="50"
          class="mx-auto my-2"
        />
        <h3 class="title-icon mx-auto">{{ item.text }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  name: 'IconsBlock',
  components: {
    Icon
  },
  data() {
    return {
      items: [
        { icon: 'new-content-daily', text: this.$t('main.purchasePlan.iconsBlock.text') },
        { icon: 'premium-support', text: this.$t('main.purchasePlan.iconsBlock.text2') },
        { icon: 'fully-editable', text: this.$t('main.purchasePlan.iconsBlock.text3') },
        { icon: 'refund', text: this.$t('main.purchasePlan.iconsBlock.text4') }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  color: $strongGray;
  font-size: 22px;
}
.svg-box {
  width: 120px;
  .title-icon {
    font-size: 15px;
    text-align: center;
    color: $strongGray;
    font-weight: 400;
    line-height: 1.5;
  }
}
</style>
